import React from 'react';
import { m } from 'framer-motion';
import { SectionTag } from '../ui/SectionTag';
import { ScrollHintTable } from '../ui/ScrollHintTable';
const rows = [{
  before: '😩 Semanas muertas esperando un cliente que no regatee',
  after: '✅ −90% tiempo muerto. Fabrica hoy, vende mañana.'
}, {
  before: '🔄 Miedo a que 50€ sea "caro" por una pieza',
  after: '✅ Confianza total. Vendes diseño y utilidad.'
}, {
  before: '📉 Retales en la basura. Dinero tirado.',
  after: '✅ Tus sobras se convierten en 45-80€.'
}, {
  before: '💼 "Soy el apañao de los recados"',
  after: '✅ "Tengo mi marca de artesanía online."'
}];
export function Transformation() {
  return <section className="bg-bg-primary py-10 sm:py-14" data-id="element-194" data-mp="21ps85cx9mnbq">
      <div className="mx-auto max-w-4xl px-4 text-center sm:px-6" data-id="element-195" data-mp="21n63bl1relx7">
        <SectionTag icon="⚡" data-id="element-196" data-mp="2z5fwkvhq8r08">La transformación</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-ink sm:text-4xl" data-id="element-197" data-mp="2ue7mrychj3mj">
          Tu semana no debería terminar con el taller lleno de serrín e incertidumbre...
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-198" data-mp="1a7spy5suqzir">
          Un domingo por la tarde, viendo ese tablero que te sobró o esas herramientas que costaron un
          dinero y no se pagan solas. Miedo a fabricar algo y que se quede cogiendo polvo porque "nadie lo
          quiere".
        </p>

        <div className="mt-6 rounded-2xl border border-brown/25 bg-brown/5 p-5 text-left sm:p-6" data-id="element-199" data-mp="mgnavsuqkb9i">
          <p className="font-heading text-sm font-bold uppercase tracking-wide text-brown" data-id="element-200" data-mp="rht55v41o6l5">
            Recupera la rentabilidad de tu ingenio
          </p>
          <p className="mt-2 text-sm leading-relaxed text-muted sm:text-base" data-id="element-201" data-mp="hiluxgslws29">
            <span className="font-semibold text-ink" data-id="element-202" data-mp="hkoi7t2dk73a">El coste real:</span> Intentar vender muebles grandes o
            esperar a que te salga una "chapuza" de reforma te quita tiempo y salud. Es hora de fabricar
            objetos que la gente desea regalar.
          </p>
        </div>
      </div>

      <div className="mx-auto mt-8 max-w-4xl px-4 sm:px-6" data-id="element-203" data-mp="3krgudztrhl9s">
        <p className="mb-4 text-center font-heading text-sm font-bold uppercase tracking-wide text-muted" data-id="element-204" data-mp="3ftfc3h45tpzd">
          Las 4 Transformaciones
        </p>
        <ScrollHintTable minWidth="600px" data-id="element-205" data-mp="3buq09syrsghu">
          <table className="w-full text-left text-sm" data-id="element-206" data-mp="36utzs3pa7771">
            <thead data-id="element-207" data-mp="7enkoanoj1j1">
              <tr className="border-b border-brown/15 bg-brown/5 text-xs uppercase tracking-wide text-muted" data-id="element-208" data-mp="7f6s2xfpe7it">
                <th className="px-5 py-3 font-semibold" data-id="element-209" data-mp="3ctnwdgluho5">Antes</th>
                <th className="px-5 py-3 font-semibold" data-id="element-210" data-mp="3urr9xr39r4s4">Ahora</th>
              </tr>
            </thead>
            <tbody data-id="element-211" data-mp="3pso2jzztgmgz">
              {rows.map((row, i) => <m.tr key={row.before} initial={{
              opacity: 0,
              y: 10
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: i * 0.08
            }} className={i !== rows.length - 1 ? 'border-b border-brown/10' : ''} data-id="element-212" data-mp="3ps4v5d7slgh7" data-mpi={i}>
                  <td className="px-5 py-4 align-top leading-relaxed text-muted" data-id="element-213" data-mp="yn8bkhfel0le">{row.before}</td>
                  <td className="px-5 py-4 align-top leading-relaxed text-ink" data-id="element-214" data-mp="13k72ys7omtfw">{row.after}</td>
                </m.tr>)}
            </tbody>
          </table>
        </ScrollHintTable>
      </div>
    </section>;
}